$(document).ready(function() {
  /**
   * Utility object which contains functions to retrieve credit card value.
   */
  const CardUtils = {
    numberFormats: {
      visa: {
        // visa, visa electron
        format: "XXXX XXXX XXXX XXXX",
        digits: 16
      },
      mastercard: {
        // mastercard
        format: "XXXX XXXX XXXX XXXX",
        digits: 16
      },
      master: {
        // mastercard
        format: "XXXX XXXX XXXX XXXX",
        digits: 16
      },
      amex: {
        // amex
        format: "XXXX XXXXXX XXXXX",
        digits: 15
      },
      maestro: {
        // maestro
        format: "XXXX XXXX XXXX XXXX",
        digits: 16
      }
    },
    /**
     * Get card's type (via, amex, etc).
     * @return {*}
     */
    getType: function() {
      return $.trim($("#cardType option:selected").val());
    },

    /**
     * Get card's number.
     * @return {*|jQuery}
     */
    getNumber: function() {
      return $("#cardNumber")
        .val()
        .replace(/\D/g, "");
    },

    /**
     * Get RAW input value of credit card.
     * @return {*|jQuery}
     */
    getRawValue: function() {
      return $("#cardNumber").val();
    },

    /**
     * Get credit card formatted number.
     * @return {string|*|jQuery}
     */
    getFormattedNumber: function() {
      const cardNumber = this.getNumber();
      const cardType = this.getType();

      if (cardType && this.numberFormats[cardType]) {
        return this.applyFormat(cardNumber, this.numberFormats[cardType].format);
      } else {
        return cardNumber;
      }
    },

    /**
     * Apply a format mask to the given card number
     *
     * @param cardNumber
     * @param mask
     * @returns {string}
     */
    applyFormat: function(cardNumber, mask) {
      let formattedString = "";
      let numberPos = 0;
      for (let j = 0; j < mask.length; j++) {
        const currentMaskChar = mask[j];
        if (currentMaskChar === "X") {
          const digit = cardNumber.charAt(numberPos);
          if (!digit) {
            break;
          }
          formattedString += cardNumber.charAt(numberPos);
          numberPos++;
        } else {
          formattedString += currentMaskChar;
        }
      }
      return formattedString;
    }
  };

  /**
   * Utility class which provides methods to handle backend requests.
   * @constructor
   */
  function CheckoutPaymentStep () {
    /**
     * Display validation error message.
     */
    this.displayValidationError = function() {
      $("#cybersourceSAFormError").removeClass("hide");
    };

    this.obtainReCaptchaToken = function(callback) {
      if (!callback) {
        return;
      }

      if (window.tk_gen && !!window.tk_gen.reCaptchaTokenToggle) {
        grecaptcha.ready(function() {
          // Reinitialize the token on submission.
          grecaptcha.execute(window.tk_gen.reCaptchaSiteKey, { action: "ecommerce" }).then(function(token) {
            callback(token);
          });
        });
      } else {
        const tokenValue =
          window.tk_gen && typeof window.tk_gen.reCaptchaToken !== "undefined" ? window.tk_gen.reCaptchaToken : "";

        callback(tokenValue);
      }
    };

    /**
     * Perform AJAX payment form validation request.
     * @return {Promise<unknown>}
     */
    this.ajaxPaymentFormValidation = function() {
      const $form = $("#cybersourceSAForm");
      return new Promise((resolve, reject) => {
        /**
         * Handle success response from server.
         * @param res
         */
        const successResponse = function(res) {
          if (res.success) {
            //disable fields if necessary
            if ($(".billing-address").is(":checked")) {
              disableBillingAddress(true);
            }

            resolve();
          } else {
            $form.attr("action", "paymentFormValidations");
            $form.submit();
            reject(new Error("paymentFormValidations"));
          }
        };

        /**
         * Handle error response from server.
         */
        const errorResponse = function() {
          const message = "Something went wrong while updating Billing Address!! Please try again.";
          $("#globalMessages ul").append("<div class='alert negative'>" + message + "</div>");
          reject(new Error(message));
        };

        $.ajax({
          type: "POST",
          url: "ajaxPaymentFormValidation",
          data: $form.serialize(),
          async: false,
          success: successResponse,
          error: errorResponse
        });
      });
    };

    /**
     * Use stored payment info
     */
    this.useStoredPaymentV2 = function() {
      const injectForm = function(formCode) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = formCode;
        document.body.append(wrapper);
        return wrapper.firstChild;
      };

      const successResponse = function(response) {
        if (!response.data || !response.data.htmlOfAutosubmitForm) {
          errorResponse(response);
          return;
        }

        const formElement = injectForm(response.data.htmlOfAutosubmitForm);
        if (formElement) {
          formElement.submit();
        }
      };

      /**
       * Handle error response from server.
       */
      const errorResponse = function(response) {
        const message = response.meta.feedback.message.basePropertyValue;
        $("#termsErrorMessageGlobal").html("<span>" + message + "</span>").removeClass("hidden");
      };

      const paymentProviderCode = "CYBERSOURCE";
      const endpointUrl =
        window.ACC.config.encodedContextPath + "/checkout/multi/payment/billingDetails/v2/paymentInit";

      const getData = function() {
        return {
          savedPaymentId: $(".form__retailer-option.selected #paymentInfoId").val(),
          paymentProviderCode: paymentProviderCode
        };
      };

      $.ajax({
        type: "POST",
        url: endpointUrl,
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(getData()),
        success: successResponse,
        error: errorResponse
      });
    };

    /**
     * Submit checkout form (V2)
     * @param token
     */
    this.submitPaymentDataV2 = function(token) {
      const endpointUrl =
        window.ACC.config.encodedContextPath + "/checkout/multi/payment/billingDetails/v2/paymentInit";

      const getFormCode = function(response) {
        let formCode = response.data.htmlOfAutosubmitForm;
        const replacements = {
          card_type: $("#temp_card_type").val(),
          card_number: $("#temp_card_number").val(),
          card_cvn: $("#temp_card_cvn").val(),
          card_expiry_date: $("#temp_card_expiry_month").val() + "-" + $("#temp_card_expiry_year").val()
        };

        Object.keys(replacements).forEach((k) => {
          formCode = formCode.replace("${" + k + "}", replacements[k]);
        });

        return formCode;
      };

      const injectForm = function(formCode) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = formCode;
        document.body.append(wrapper);
        return wrapper.firstChild;
      };

      const successResponse = function(response) {
        if (!response.data || !response.data.htmlOfAutosubmitForm) {
          errorResponse(response);
          return;
        }

        const formElement = injectForm(getFormCode(response));
        if (formElement) {
          formElement.submit();
        }
      };

      /**
       * Handle error response from server.
       * @param error
       */
      const errorResponse = function(response) {
        const message = response.meta.feedback.message.basePropertyValue;
        const $errorMessages = $("#globalMessages ul");
        if (!$("#globalMessages ul").length && $("#cybersourceSAFormError").length) {
          $("#cybersourceSAFormError")
            .removeClass("hide")
            .html(message);
        } else {
          $("#globalMessages ul").append("<div class='alert negative'>" + message + "</div>");
        }

        const errorFields = response.meta.feedback.errorFields;
        if (errorFields && Object.keys(errorFields).length) {
          Object.keys(errorFields).forEach(function(field) {
            const $field = $("[name=\"" + field + "\"]");
            const message = errorFields[field];

            if ($field.length > 0) {
              const $errorMessageContainer = $field.parent().next(".form__message");
              if ($errorMessageContainer && $errorMessageContainer.length > 0) {
                $errorMessageContainer.show().html(message);
              }
            }
          });
        }
      };

      /**
       * Get data to be sent to server.
       * @return {}
       */
      const getData = function() {
        const paymentProviderCode = $("input[name=payment_provider]:checked").val() || $("#paymentProvider").val();

        return {
          billingAddress: {
            firstName: $("#bill_to_forename").val(),
            lastName: $("#bill_to_surname").val(),
            line1: $("#bill_to_address_line1").val(),
            line2: $("#bill_to_address_line2").val(),
            townCity: $("#bill_to_address_city").val(),
            regionIso: $("#bill_to_address_state").val(),
            postcode: $("#bill_to_address_postal_code").val(),
            phone: $("#bill_to_phone").val(),
            countryIso: $("#bill_to_address_country_code").val()
          },
          expiryMonth: $("#temp_card_expiry_month").val(),
          expiryYear: $("#temp_card_expiry_year").val(),
          cardTypeCode: $("#temp_card_type").val(),
          saveInAccount: $("#savePaymentInfo").is(":checked"),
          newBillingAddress: !$("#sameAsDeliveryAddr").is(":checked"),
          paymentProviderCode: paymentProviderCode,
          paymentOption: $("#paymentOption").val(),
          reCaptchaToken: token
        };
      };

      $.ajax({
        type: "POST",
        url: endpointUrl,
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify(getData()),
        success: successResponse,
        error: errorResponse
      });
    };
  }

  function billingSuccess (response) {
    $("#bill_to_title").val(response.responseObject.titleCode);

    const selectedVal = $("select[id=bill_to_title] option:selected").text();
    $("#select_bill_to_title").html(selectedVal);
    $("#bill_to_forename").val(response.responseObject.firstName);
    $("#bill_to_surname").val(response.responseObject.lastName);
    $("#bill_to_phone").val(response.responseObject.phone);
    $("#bill_to_address_line1").val(response.responseObject.line1);
    $("#bill_to_address_line2").val(response.responseObject.line2);
    $("#bill_to_address_city").val(response.responseObject.town);

    const region = response.responseObject.region;
    let setRegion = false;
    const $select = $("#bill_to_address_state");
    let selectedValue = $("select[id=bill_to_address_state] option:selected").val();
    let selectedText = $("select[id=bill_to_address_state] option:selected").text();

    if (region && region.isocode && region.isocode.length > 0) {
      const $option = $select.find("option[value=\"" + region.isocode + "\"]");
      if ($option.length > 0) {
        $("#bill_to_address_state option:selected").each(function() {
          $(this).removeAttr("selected");
        });
        $option.prop("selected", true);
        setRegion = true;
        selectedValue = $("select[id=bill_to_address_state] option[value='" + region.isocode + "']").val();
        selectedText = $("select[id=bill_to_address_state] option[value='" + region.isocode + "']").text();
      }
    }
    if (!setRegion) {
      const $naOption = $select.find("option:nth-child(2)");
      $naOption.attr("selected", "selected");
      $("#select_bill_to_address_state").text($naOption.text());
    }
    $("#bill_to_address_state").val(selectedValue);
    $("#select_bill_to_address_state").html(selectedText);
    $("#bill_to_address_postal_code").val(response.responseObject.postalCode);
    $("#bill_to_address_house_number").val(response.responseObject.houseNumber);
    disableBillingAddress(true);
  }

  function billingError () {
    $("#globalMessages ul").append("<div class='alert negative'>Something went wrong!! Please try again.</div>");
    disableBillingAddress(false);
  }

  function disableBillingAddress (toggle) {
    if (toggle) {
      $("#bill_to_title").attr("disabled", "disabled");
      $("#bill_to_forename").attr("disabled", "disabled");
      $("#bill_to_surname").attr("disabled", "disabled");

      if ($("#bill_to_phone").val() !== "") {
        $("#bill_to_phone").attr("disabled", "disabled");
      }
      $("#bill_to_address_line1").attr("disabled", "disabled");
      $("#bill_to_address_line2").attr("disabled", "disabled");
      $("#bill_to_address_city").attr("disabled", "disabled");
      $("#bill_to_address_state").attr("disabled", "disabled");
      $("#select_bill_to_address_state")
        .addClass("form__item--disabled")
        .removeClass("arrow-down-isolated-icon-after");
      $("#bill_to_address_postal_code").attr("disabled", "disabled");
      $("#bill_to_address_house_number").attr("disabled", "disabled");
    } else {
      $("#bill_to_title").removeAttr("disabled");
      $("#bill_to_forename").removeAttr("disabled");
      $("#bill_to_surname").removeAttr("disabled");
      $("#bill_to_phone").removeAttr("disabled");
      $("#bill_to_address_line1").removeAttr("disabled");
      $("#bill_to_address_line2").removeAttr("disabled");
      $("#bill_to_address_city").removeAttr("disabled");
      $("#bill_to_address_state").removeAttr("disabled");
      $("#select_bill_to_address_state")
        .removeClass("form__item--disabled")
        .addClass("arrow-down-isolated-icon-after");
      $("#bill_to_address_postal_code").removeAttr("disabled");
      $("#bill_to_address_house_number").removeAttr("disabled");
    }
  }

  function showFormError (groupName) {
    const groupParent = $("#" + groupName).closest("li");
    const trimmedContent = $.trim(groupParent.html());

    if (trimmedContent.indexOf("form__item--error") === -1) {
      //form validation message not rendered yet
      const newContent = "<div class=\"form__item--error alert-icon-after\">" + trimmedContent + "</div>";
      const postalCodeErrorMessage = $(".form__item--error").find("input[id='bill_to_address_postal_code']");
      var houseNumberErrorMessage = $(".form__item--error").find("input[id='bill_to_address_house_number']");
      postalCodeErrorMessage.closest("div.form__item--error").removeClass("alert-icon-after");
      houseNumberErrorMessage.closest("div.form__item--error").removeClass("alert-icon-after");
      groupParent.empty().append(newContent);
      groupParent.find("em.form__message").show();
    }
  }

  function hideFormError (groupName, fieldName, fieldValue) {
    const groupParent = $("#" + groupName).closest("li");
    const trimmedContent = $.trim(groupParent.html());

    if (trimmedContent.indexOf("form__item--error") !== -1) {
      const newContent = $(trimmedContent).html();

      groupParent.empty().append(newContent);
      $("#" + fieldName).val(fieldValue);
      groupParent.find("em.form__message").hide();
    }
  }

  function validateFields (validationData, errorFields = []) {
    for (let key in validationData) {
      const $field = $(`#${key}`);
      const value = $field.val();
      $field.attr("value", value);

      const regex = validationData[key].regex();

      if (!value.match(regex)) {
        errorFields.push($(`#${key}`));
      } else {
        hideFormError(key, key, value);
      }

      window.dispatchEvent(new Event('trek:format.phone.field'));
    }

    if (errorFields.length > 0) {
      $(errorFields).each(function() {
        showFormError($(this).attr("id"));
      });
      $("html, body").animate(
        { scrollTop: $("#page").offset().top },
        500
      );
    }

    return errorFields;
  }

  function validateBillingAddress () {
    const hidPostcodeRegex = $("input[name=hidPostcodeRegex]").val()
      ? $("input[name=hidPostcodeRegex]").val()
      : "^[0-9]{5,5}$";

    const validationData = {
      bill_to_address_postal_code: {
        regex: function() {
          return hidPostcodeRegex;
        }
      }
    };

    let isContactFieldsOk = true;
    const errorFields = [],
      inputFields = $("#cybersourceSAForm").find(
        "input[required='true'],input[required='required'],select[required='true'],select[required='required']"
      );

    inputFields.each(function() {
      if ($(this).is("SELECT") && !$.trim($(this).val()).length) {
        const elementId = $(this).attr("id");
        const elementValue = $("#" + elementId + " option[selected]").val();
        if (!$.trim(elementValue).length) {
          errorFields.push(this);
        } else {
          hideFormError($(this).attr("id"), $(this).attr("id"), elementValue);
        }
      } else if (!$.trim($(this).val()).length) {
        errorFields.push(this);
      } else {
        hideFormError($(this).attr("id"), $(this).attr("id"), $(this).val());
      }
    });

    return !validateFields(validationData, errorFields).length;
  }

  function validateCreditCard (isValidateBillingAddress = true) {
    const country = !window.ACC ? "en_US" : window.ACC.languageISO;

    let isContactFieldsOk = true;
    if (isValidateBillingAddress) {
      isContactFieldsOk = validateBillingAddress();
    }

    let validationData = {
      card_cvn: {
        regex: function() {
          return /^[0-9]{3,4}$/;
        }
      }
    };

    if (country === "en_GB") {
      validationData["card_cvn"] = {
        regex: function() {
          return /^[0-9]{3,4}$/;
        }
      };
    }

    validateFields(validationData);

    let cardTypeOk = true;
    let cardNumberOk = true;
    let cardNameOk = true;
    let cardCvnOk = true;
    let cardMonthOk = true;
    let cardYearOk = true;
    const cardType = $.trim($("#cardType option:selected").val());

    if (!$("#cardType")[0].selectedIndex) {
      cardTypeOk = false;
    }

    if (!cardTypeOk) {
      showFormError("cardType");
    } else {
      hideFormError("cardType", "cardType", cardType);
    }

    const cardNumber = CardUtils.getNumber();
    if (cardNumber === "") {
      cardNumberOk = false;
    } else if (cardNumber.length > 16 || cardNumber.length < 13) {
      cardNumberOk = false;
    } else if (!$.isNumeric(cardNumber)) {
      cardNumberOk = false;
    }

    if (!cardNumberOk) {
      showFormError("cardNumber");
    } else {
      hideFormError("cardNumber", "cardNumber", cardNumber);
    }

    const name = $.trim($("#nameOnCard").val());
    if (name === "") {
      $("#cardNameError").show();
      cardNameOk = false;
    }

    if (!cardNameOk) {
      showFormError("nameOnCard");
    } else {
      hideFormError("nameOnCard", "nameOnCard", name);
    }

    const cvn = $.trim($("#card_cvn").val());
    if (cvn === "") {
      cardCvnOk = false;
    } else if (cvn.length > 4 || cvn.length < 3) {
      cardCvnOk = false;
    } else if (!$.isNumeric(cvn)) {
      cardCvnOk = false;
    }

    if (!cardCvnOk) {
      showFormError("card_cvn");
    } else {
      hideFormError("card_cvn", "card_cvn", cvn);
    }

    const expiryMonth = $.trim($("#ExpiryMonth option:selected").val());
    if (!$("#ExpiryMonth")[0].selectedIndex) {
      cardMonthOk = false;
    }

    if (!cardMonthOk) {
      showFormError("ExpiryMonth");
    } else {
      hideFormError("ExpiryMonth", "ExpiryMonth", expiryMonth);
    }

    const expiryYear = $.trim($("#ExpiryYear option:selected").val());
    if (!$("#ExpiryYear")[0].selectedIndex) {
      cardYearOk = false;
    }

    if (!cardYearOk) {
      showFormError("ExpiryYear");
    } else {
      hideFormError("ExpiryYear", "ExpiryYear", expiryYear);
    }

    if (
      !cardTypeOk ||
      !cardNumberOk ||
      !cardNameOk ||
      !cardCvnOk ||
      !cardMonthOk ||
      !cardYearOk ||
      !isContactFieldsOk
    ) {
      // Have to re-attach the event handlers after they are lost with trimmedContent = $.trim(groupParent.html());
      initializeCreditCardFields();
      return false;
    } else {
      return true;
    }
  }

  function validateIdeal () {
    const isContactFieldsOk = validateBillingAddress();
    let isBankNameOk = true;

    const bankName = $("#paymentOption").val();
    if (!bankName) {
      $("#bankError").show();
      isBankNameOk = false;
      $("html, body").animate(
        { scrollTop: $("#page").offset().top },
        500
      );
    } else {
      $("#bankError").hide();
    }

    return isContactFieldsOk && isBankNameOk;
  }

  function clearCreditCardFormFields () {
    //save em
    $("#temp_card_type").val($.trim($("#cardType option:selected").val()));
    $("#temp_card_number").val(CardUtils.getNumber());
    $("#temp_card_name").val($.trim($("#nameOnCard").val()));
    $("#temp_card_cvn").val($.trim($("#card_cvn").val()));
    $("#temp_card_expiry_month").val($.trim($("#ExpiryMonth option:selected").text()));
    $("#temp_card_expiry_year").val($.trim($("#ExpiryYear option:selected").text()));

    //clear em
    $("#cardType").val("");
    $("#cardNumber").val("");
    $("#nameOnCard").val("");
    $("#card_cvn").val("");
    $("#ExpiryMonth").val("");
    $("#ExpiryYear").val("");
  }

  function getCheckoutPaymentStepInstance () {
    const checkoutPaymentStep = new CheckoutPaymentStep();
    const totalPaymentProviders = $("input[name=payment_provider]").length;
    let paymentProvider = $("input[name=payment_provider]:checked").val();

    $("#payment-provider-error-message").hide();

    if (!paymentProvider) {
      if (totalPaymentProviders < 2) {
        paymentProvider = $("#paymentProvider").val();
      }

      if (!paymentProvider) {
        $("#payment-provider-error-message").show();
        return null;
      }
    }

    const isFormValid = paymentProvider === "CYBERSOURCE" ? validateCreditCard() : validateIdeal();

    if (!isFormValid) {
      checkoutPaymentStep.displayValidationError();
      return null;
    }

    // Enable fields so they can be posted in request
    if ($(".billing-address").is(":checked")) {
      disableBillingAddress(false);
    }

    clearCreditCardFormFields();
    return checkoutPaymentStep;
  }

  function initializePaymentProviders () {
    const getPaymentMethods = () => {
      const methods = [];
      $("[data-payment-method]").each(function() {
        methods.push({
          controller: $(this),
          target: $($(this).data("payment-method"))
        });
      });
      return methods;
    };

    const hidePaymentMethods = () => {
      const methods = getPaymentMethods();
      methods.forEach(method => {
        method.target.addClass("hidden");
      });
    };

    const showMethod = (method = null) => {
      const selectedMethod = method || $("[data-payment-method]:checked");
      if (!selectedMethod || !selectedMethod.length) {
        const paymentMethodForms = $("[data-payment-method-form]");
        if (paymentMethodForms && paymentMethodForms.length === 1) {
          $("[data-payment-method-form]:first").removeClass("hidden");
        }
        return;
      }

      $(selectedMethod.data("payment-method")).removeClass("hidden");
    };

    const handleSwitch = () => {
      const methods = getPaymentMethods();
      methods.forEach(method => {
        method.controller.on("change", function() {
          hidePaymentMethods();
          showMethod();
        });
      });
    };

    handleSwitch();
    showMethod();
  }

  /**
   * Initialize checkout payment step.
   */
  function initializeCheckoutPaymentStep () {
    $("#checkoutReviewAndOrder").click(function(e) {
      e.preventDefault();
      const checkoutPaymentStep = getCheckoutPaymentStepInstance();
      if (!checkoutPaymentStep) {
        return;
      }

      checkoutPaymentStep.obtainReCaptchaToken(checkoutPaymentStep.submitPaymentDataV2);
    });

    if ($("#payment_provider").length > 0) {
      initializePaymentProviders();
    }
  }

  /**
   * Initialize credit card fields.
   */
  function initializeCreditCardFields () {
    // Initialize credit card formatting after credit card type is selected
    $("#cardType").change(function() {
      const cardType = CardUtils.getType();
      if (cardType && CardUtils.numberFormats[cardType]) {
        $("#cardNumber__help").text(CardUtils.numberFormats[cardType].format);
      }
      if (CardUtils.getNumber()) {
        $("#cardNumber").val(CardUtils.getFormattedNumber());
      }
    });

    $("#cardNumber").blur(function() {
      $(this).val(CardUtils.getFormattedNumber());
    });
  }

  /**
   * Initialize logic for 'same as delivery address' checkbox.
   */
  function initializeSameAsDeliveryAddress () {
    const sameAsDeliveryAddrCheckbox = $("#sameAsDeliveryAddr");
    const $select = $("#bill_to_address_state");
    const $defaultOption = $select.find("option:nth-child(1)");

    sameAsDeliveryAddrCheckbox.change(function(event) {
      if ($(this).is(":checked")) {
        $.ajax({
          type: "GET",
          url: "sameAsDeliveryAddress",
          success: billingSuccess,
          error: billingError
        });
      } else if ($(this).not(":checked")) {
        $defaultOption.attr("selected", "selected");
        $("#bill_to_title").val("");
        $("#select_bill_to_title").text("Select");
        $("#bill_to_forename").val("");
        $("#bill_to_surname").val("");
        $("#bill_to_phone").val("");
        $("#bill_to_address_line1").val("");
        $("#bill_to_address_line2").val("");
        $("#bill_to_address_city").val("");
        $("#bill_to_address_state").val("");
        $("#select_bill_to_address_state").text($defaultOption.text());
        $("#bill_to_address_postal_code").val("");
        disableBillingAddress(false);
      }
    });

    // Set billing address to be the same as shipping address by default
    if (
      sameAsDeliveryAddrCheckbox.not(":checked") &&
      !$("#bill_to_title").val() &&
      !$("#bill_to_forename").val() &&
      !$("#bill_to_surname").val() &&
      !$("#bill_to_phone").val() &&
      !$("#bill_to_address_line1").val() &&
      !$("#bill_to_address_line2").val() &&
      !$("#bill_to_address_city").val() &&
      !$("#bill_to_address_state").val() &&
      !$("#bill_to_address_postal_code").val()
    ) {
      sameAsDeliveryAddrCheckbox.click();
    }
  }

  /**
   * Initialize checkout form handlers.
   */
  function initializeFormHandlers () {
    $("#cybersourceSAForm").submit(function() {
      $("#paymentId").attr("name", "");
    });

    $("#checkout-step3-wallet-choosePaymentMethodBtnV2").click(function() {
      const checkoutPaymentStep = new CheckoutPaymentStep();
      checkoutPaymentStep.useStoredPaymentV2();
    });
  }

  /**
   * Handle global error messages
   */
  function initializeGlobalErrorMessages () {
    const globalMessages = window.cybersourceGlobalErrors;
    if (!globalMessages || !globalMessages.length) {
      return;
    }

    if (globalMessages.includes("checkout.error.payment.not.accepted")) {
      validateCreditCard(false);
    }
  }

  // Entry point
  initializeCreditCardFields();
  initializeSameAsDeliveryAddress();
  initializeFormHandlers();
  initializeCheckoutPaymentStep();
  initializeGlobalErrorMessages();
});
